 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML00_XXX from '@/components/html/00_xxx'
 import HTML02_SERIES_P from '@/components/html/02_Series_P'
 import HTML03_TITLE_PA from '@/components/html/03_Title_Pa'
 import HTML04_COPYRIGH from '@/components/html/04_Copyrigh'
 import HTML05_CONTENTS from '@/components/html/05_Contents'
 import HTML06_1_IN_LIN from '@/components/html/06_1_In_Lin'
 import HTML07_I__LAST from '@/components/html/07_I__Last'
 import HTML08_II__DIGG from '@/components/html/08_II__Digg'
 import HTML09_III__THE from '@/components/html/09_III__The'
 import HTML10_ACKNOWLE from '@/components/html/10_Acknowle'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_Contents",
 			"name" : "html/05_Contents",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_1_In_Lin",
 			"name" : "html/06_1_In_Lin",
 			"component" : HTML06_1_IN_LIN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js